import type { WorkItem } from "@baton/api";
import { create } from "zustand";

/**
 * The task the one Remind dialog the shell mounts is open on (020 FR-020-278, `RemindDialog.tsx`),
 * which a task's row menu and its header set. The shell reads it to load the dialog on its first
 * opening, so it is a module of its own, apart from the send (`remind.ts`, FR-015-120, 2026-10-05).
 */
export type RemindTarget = Pick<WorkItem, "id" | "identifier" | "title" | "assignees">;

interface RemindState {
  readonly target: RemindTarget | null;
  readonly open: (target: RemindTarget) => void;
  readonly close: () => void;
}

export const useRemindStore = create<RemindState>((set) => ({
  target: null,
  open: (target) => {
    set({ target });
  },
  close: () => {
    set({ target: null });
  },
}));
